import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import apiHelperService from '@/services'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

const getRefundRequest = async () => {
  const formStore = useFormStore()
  const { moduleId, departmentCode, serviceYear, typeCode, sequenceNumber } = formStore.form.values

  try {
    const res = await apiHelperService.get('/api/refundRequest/fileNumber', {
      params: {
        moduleId,
        departmentCode,
        serviceYear,
        typeCode,
        sequenceNumber
      }
    })
    return res
  } catch (error) {
    formStore.form.setValues({
      departmentCode: '',
      serviceYear: '',
      typeCode: '',
      sequenceNumber: '',
      referenceRequestNumber: ''
    })
    doNotify(i18n.global.t('invalidFileNumber'), i18n.global.t('invalidFileNumber'))
  }
}

const getRequestNumber = async () => {
  const formStore = useFormStore()
  const { departmentCode, serviceYear, typeCode, sequenceNumber } = formStore.form.values
  if (!departmentCode || !serviceYear || !typeCode || !sequenceNumber) {
    return
  }
  const res = await getRefundRequest()
  formStore.form.setFieldValue('referenceRequestNumber', res.number)
}

export default function (actionName, actionParams) {
  switch (actionName) {
    case 'getRequestNumber':
      getRequestNumber(actionParams)
    default:
      break
  }
}
